export default "__VITE_ASSET__D$Dwd78d__"